import ContentLayout from './ContentLayout'

export const variantConstants = {
  LIGHT: 'light',
  DARK: 'dark',
}

export default ContentLayout
